import { $ } from '@/libs/jquery/index'

export enum CollapserEvents {
  Base = 'data-should-uncolapse',
}

export class Collapser {
  private selectors: ISelectors = {
    base: '[data-should-uncolapse]',
  }

  private classes: ISelectors = {
    uncollapse: 'uncolapse-done',
  }

  public constructor() {
    this.init()
  }

  private init(): void {
    $('body')
      .on('click', this.selectors.base, (e) => this.toggle($(e.currentTarget)))
  }

  private isCollapsed($target: JQuery): boolean {
    return !$target.hasClass(this.classes.uncollapse)
  }

  private getId($target: JQuery): string {
    return $target.attr(CollapserEvents.Base)
  }

  private getContent($target: JQuery): JQuery {
    return $(`[data-colapsing-content='${ this.getId($target) }']`)
  }

  private trigger(): void {
    $(document).trigger(CollapserEvents.Base)
  }

  private toggle($target: JQuery): void {
    if (this.isCollapsed($target)) {
      this.uncollapse($target)
    } else {
      this.collapse($target)
    }
  }

  private collapse($target: JQuery): void {
    if (this.getId($target)) {
      $target.removeClass(this.classes.uncollapse)
      this.getContent($target).stop().slideUp()
      this.trigger()
    }
  }

  private uncollapse($target: JQuery): void {
    if (this.getId($target)) {
      $target.addClass(this.classes.uncollapse)
      this.getContent($target).stop().slideDown()
      this.trigger()
    }
  }
}
